import React from "react";
import { Box, Stack, Tooltip, Typography } from "@mui/material";
import { nFormatter } from "../../../Helpers";
import { ExdEmpty } from "../../ExDashboard/components/exdMui";
import { MD } from "./mdTheme";
import { FiltersOption } from "./constants";
import { MdWidgetCard, MdPeriodSelect } from "./MdCardShell";

const BAR_COLORS = [MD.chart[0], MD.chart[4], MD.chart[3]];

const UnitSalesCard = ({
  translate,
  loading,
  total,
  parts,
  services,
  packages,
  partsPct,
  servicesPct,
  packagesPct,
  periodValue,
  onPeriodChange,
}) => {
  const rows = [
    { label: translate("parts"), value: parts, pct: partsPct, color: BAR_COLORS[0] },
    {
      label: translate("services"),
      value: services,
      pct: servicesPct,
      color: BAR_COLORS[1],
    },
    {
      label: translate("packages"),
      value: packages,
      pct: packagesPct,
      color: BAR_COLORS[2],
    },
  ];

  return (
    <MdWidgetCard
      loading={loading}
      eyebrow={translate("unitSalesbyCategory") || "Unit Sales by Category"}
      infoTitle={translate("mdUnitSalesInfo")}
      title={
        <>
          {translate("totalRequests")}{" "}
          <Box
            component="span"
            sx={{ color: MD.muted, fontFamily: MD.fontUi, fontSize: 12, fontWeight: 400 }}
          >
            <Tooltip title={Number(total || 0).toLocaleString()}>
              <span>{total ? nFormatter(total, 2) : "0"}</span>
            </Tooltip>
          </Box>
        </>
      }
      controls={
        onPeriodChange ? (
          <MdPeriodSelect
            value={periodValue}
            onChange={onPeriodChange}
            options={FiltersOption}
            fallbackLabel="ALL"
          />
        ) : null
      }
    >
      <Stack spacing={1.25} sx={{ mt: 0.5, flex: 1, justifyContent: "center" }}>
        {rows.some((r) => Number(r.value) > 0) ? (
          rows.map((row) => (
            <Box
              key={row.label}
              sx={{
                display: "grid",
                gap: "5px 10px",
                gridTemplateColumns: "minmax(0, 1fr) auto",
                alignItems: "center",
                fontSize: 12.5,
              }}
            >
              <Typography sx={{ color: MD.fg, fontWeight: 500, m: 0 }}>
                {row.label}
              </Typography>
              <Typography
                sx={{
                  fontFamily: MD.fontHead,
                  fontWeight: 600,
                  m: 0,
                }}
              >
                {Number(row.value || 0).toLocaleString()}
              </Typography>
              <Box
                sx={{
                  bgcolor: MD.line2,
                  borderRadius: "4px",
                  gridColumn: "1 / -1",
                  height: 12,
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    bgcolor: row.color,
                    borderRadius: "4px",
                    height: "100%",
                    width: `${Math.min(Math.max(Number(row.pct) || 0, 0), 100)}%`,
                  }}
                />
              </Box>
            </Box>
          ))
        ) : (
          <ExdEmpty />
        )}
      </Stack>
    </MdWidgetCard>
  );
};

export default UnitSalesCard;
